import setting from '@/setting.js'

// 导入工具模板动态路由配置文件
import kitRouterConfig from '@/libs/kit/routerConfigTools.js'

/**
 * 元数据
 * @type {{requiresAuth: boolean}} requiresAuth为true表示需要授权登录后访问
 */
const meta = {requiresAuth: false}

/**
 * 自动布局
 */
import layout from '@/layout/header-aside/auto-layout'

/**
 * 在主框架内显示
 */
const frameIn = [
    {
        path: '/',
        redirect: {path: '/home'},
        meta,
        component: layout,
        children: [
            {
                path: 'home',
                name: 'home',
                meta,
                component: () => import('@/pages/portal-a-home')
            },
            {
                path: 'resource',
                name: 'resource',
                meta,
                component: () => import('@/pages/portal-b-resource')
            },
            {
                path: 'solutions',
                name: 'solutions',
                meta,
                component: () => import('@/pages/portal-b-solutions')
            },
            {
                path: 'platform',
                name: 'platform',
                meta,
                component: () => import('@/pages/portal-c-platform')
            },
            {
                path: 'hosting',
                name: 'hosting',
                meta, 
                component: () => import('@/pages/portal-d-hosting')
            },
            {
                path: 'tech',
                name: 'tech',
                meta,
                component: () => import('@/pages/portal-c-tech')
            },
            {
                path: 'resources',
                name: 'resources',
                meta,
                component: () => import('@/pages/portal-e-resources')
            },
            {
                path: 'supports',
                name: 'supports',
                meta,
                component: () => import('@/pages/portal-f-supports')
            },
            {
                path: 'sptResources',
                name: 'sptResources',
                meta,
                component: () => import('@/pages/portal-f-sptResources')
            },
            {
                path: 'successMsg',
                name: 'successMsg',
                meta,
                component: () => import('@/pages/portal-f-successMsg')
            },
            {
                path: 'm/sptResources',
                name: 'm-sptResources',
                meta,
                component: () => import('@/pages/portal-f-m-sptResources')
            },
            {
                path: 'm/successMsg',
                name: 'm-successMsg',
                meta,
                component: () => import('@/pages/portal-f-m-successMsg')
            },
            {
                path: 'login',
                name: 'login',
                meta,
                component: () => import('@/pages/portal-login/page.vue')
            },
            {
                path: 'register',
                name: 'register',
                meta,
                component: () => import('@/pages/portal-register/page.vue')
            },
            {
                path: 'dashboard',
                name: 'dashboard',
                meta,
                component: () => import('@/pages/portal-dashboard/page.vue')
            },
            {
                path: 'registerSuccess',
                name: 'registerSuccess',
                meta,
                component: () => import('@/pages/portal-registerSuccess/page.vue')
            },

            {
                path: 'domesticH200',
                name: 'domesticH200',
                meta,
                component: () => import('@/pages/portal-domesticH200/page.vue')
            },
        ]
    },

]

/**
 * 在主框架之外显示
 */
const frameOut = [
    // 登陆
    {
        path: '/login',
        name: 'login',
        // component: () => import('@/pages/login-ui/loginUI')
        component: () => import('@/pages/login/page.vue')
    },
    // 登陆
    {
        path: '/register',
        name: 'login',
        // component: () => import('@/pages/login-ui/loginUI')
        component: () => import('@/pages/portal-register/page.vue')
    },
    // 大屏
    {
        path: '/overall',
        name: 'overall',
        component: () => import('@/pages/overall/page.vue')
    }
]

/**
 * 错误页面
 */
const errorPage = [
    // 404
    {
        path: '*',
        name: '404',
        component: () => import('@/pages/error-page-404')
    },
]

// 导出需要显示菜单的
export const frameInRoutes = [
    ...frameIn,
]

// 重新组织后导出
export default [
    ...frameInRoutes,
    ...frameOut,
    ...errorPage
]
